import React, {Component} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import SnackBar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { API } from "aws-amplify";

const mapStateToProps = state => {
  return { message: state.message };
};

const textColor = {
  color: '#ffffff'
}

class ContactForm extends Component {
    state = {
        showModal: false,
        email: "",
        message: "",
        validEmail: true,
        confirmationSnackbarOpen: false
      };

  handleSubmit = async event => {
    
        this.setState({ isLoading: true });
    
        try {
          await this.sendMessage({
            email : this.state.email,
            message : this.state.message
          });
          //this.props.history.push("/");
        } catch (e) {
          alert(e);
        }

        this.setState({ showModal: false, confirmationSnackbarOpen: true, isLoading: false });
  }
  
  sendMessage(messagePayload) {
    return API.post("contactform", "/contactform", {
      body: messagePayload
    });
  }

  handleClick() {
    this.setState({ open: true})
  }

  validateEmail(email) {
    const regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    this.setState({ email: email })
    return regex.test(email) ? this.setState({ validEmail: true }) : this.setState({ validEmail: false })
  }
  
  componentWillReceiveProps(nextProps){
    if (this.props.message !== nextProps.message){
        this.setState({
        showModal: true
      })
    }      
  }

  render() {
    const { showModal, email, message, validEmail, confirmationSnackbarOpen } = this.state
    const formFilled = email && message && validEmail
    return (
      <div>
        <Dialog
          modal={true}
          open={showModal}
          onClose={() => this.setState({showModal: false})}
          aria-labelledby="form-dialog-title"
          title="Contact Me"
          maxWidth="xs"
          >
          <DialogTitle id="form-dialog-title">
          <AppBar position="static">
              <Toolbar>
              <Typography 
                id="contactFormTitle" 
                variant="title" 
                style={textColor}>Contact Me</Typography>
              </Toolbar>
              </AppBar>  
          </DialogTitle>
          <DialogContent>
              <DialogContentText>
              <form>
              <TextField
                label="Your Email"
                value={email}
                fullWidth
                margin="dense"
                onChange={(event) => this.validateEmail(event.target.value)}
              />
              <TextField
                label="Message (multi-line)"
                multiline
                value={message}
                fullWidth
                margin="dense"
                onChange={(event) => this.setState({message: event.target.value})}
              />
              </form>
              </DialogContentText>
          </DialogContent>
          <DialogActions>
                <Button variant="contained"
                        onClick={(event) => this.handleSubmit(event)} 
                        style={textColor}
                        color="primary"
                        disabled={!formFilled }>
                        Send Message
                </Button>
          </DialogActions>
        </Dialog>
        <SnackBar
            open={confirmationSnackbarOpen}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            message={'Your message was sent'}
            autoHideDuration={6000}
            onClose={() => this.setState({ confirmationSnackbarOpen: false })} 
            action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={() => this.setState({ confirmationSnackbarOpen: false })}
            >
              <CloseIcon />
            </IconButton>
            ]}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(ContactForm);



// WEBPACK FOOTER //
// ./src/components/ContactForm.js